import { Component, input } from '@angular/core';

import { IonItem, IonLabel, IonNote, IonText } from '@ionic/angular/standalone';

import { IconNames } from '../../../shared';
import { SvgIconComponent } from '../../icons';

@Component({
    selector: 'lib-actionable-item-with-icon',
    imports: [IonItem, SvgIconComponent, IonLabel, IonText, IonNote],
    templateUrl: './actionable-item-with-icon.component.html',
    styleUrl: './actionable-item-with-icon.component.css'
})
export class ActionableItemWithIconComponent {
    leftIconName = input.required<IconNames>();
    rightIconName = input.required<IconNames>();

    text = input.required<string>();
    note = input.required<string>();
}
